import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { menu } from 'utils/constants';
import PrivateLayout from 'hoc/PrivateLayout';
import EstateObjectTable from 'pages/analysis/analysis/EstateObjectTable';
import Pricing from 'pages/pricing';
import Subscribe from 'pages/subscribe';
import SubscriptionManage from 'pages/subscription';
import AlertSettings from 'pages/alert';

const Private = () => {
  return (
    <Routes>
      <Route element={<PrivateLayout />}>
        <Route
          path={menu.analysis.estateObjectList.link}
          element={<EstateObjectTable />}
        />
        <Route path={menu.pricing.link} element={<Pricing />} />
        <Route path={menu.subscribe.link} element={<Subscribe />} />
        <Route path={menu.subscription.link} element={<SubscriptionManage />} />
        <Route path={menu.alert.link} element={<AlertSettings />} />
        <Route
          path="*"
          element={<Navigate to={menu.analysis.estateObjectList.link} />}
        />
      </Route>
    </Routes>
  );
};

export default React.memo(Private);
